import { FoodsIconButton, FoodsTags } from "@foodpilot/foods";
import { Stack, Box, Typography, useTheme, Grid } from "@mui/material";
import { StatusTag } from "src/components/Actions/Common/StatusTag";
import { useActionsContext } from "src/context/Actions/useActionsContext";

export type ActionType = {
    id: string | null;
    actionId: number;
    actionTitle: string;
    dateLabel: string | null;
    value: number | null;
    unit: string;
    type: string | undefined;
};

export type RowActions = {
    addAction: {
        helperText?: string;
        action: (option: ActionType) => void;
    };
    editAction: {
        helperText?: string;
        action: (option: ActionType) => void;
    };
    deleteAction: {
        helperText?: string;
        action: (option: ActionType) => void;
    };
};

export type ActionRowProps = ActionType & RowActions;
export const ActionRow = (props: ActionRowProps) => {
    const theme = useTheme();
    const { isEditMode } = useActionsContext();
    const { editAction, addAction, ...actionItem } = props;
    const { actionTitle, type, dateLabel, value, unit } = actionItem;

    const isAdded = actionItem.id !== null;
    return (
        <Stack flexDirection={"row"} padding={theme.spacing(1, 0, 1, 0)}>
            <Grid container>
                <Grid item xs={5} alignItems={"center"} display={"flex"}>
                    <Typography variant="body-medium">{actionTitle}</Typography>
                </Grid>
                <Grid item xs={7}>
                    <Grid container>
                        <Grid item xs={3} alignItems={"center"} display={"flex"} justifyContent={"center"}>
                            <StatusTag label={type} />
                        </Grid>
                        <Grid item xs={4} alignItems={"center"} display={"flex"} justifyContent={"center"}>
                            {dateLabel !== null && (
                                <FoodsTags disabled startIcon="calendar" label={dateLabel} variant="tags-white" />
                            )}
                        </Grid>
                        <Grid item xs={4} alignItems={"center"} display={"flex"} justifyContent={"center"}>
                            <Stack flexDirection={"row"} gap={theme.spacing(1)} alignItems={"center"}>
                                <Typography variant="body-bold">{value}</Typography>
                                <Typography variant="body">{unit}</Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={1}>
                            {isEditMode &&
                                (isAdded ?
                                    <FoodsIconButton
                                        size={"s"}
                                        icon="edit"
                                        buttonProps={{
                                            onClick: () => {
                                                editAction.action(actionItem);
                                            },
                                        }}
                                        tooltip={{
                                            text: editAction.helperText,
                                            props: { placement: "top" },
                                        }}
                                    />
                                :   <FoodsIconButton
                                        size={"s"}
                                        icon="add"
                                        buttonProps={{
                                            onClick: () => {
                                                addAction.action(actionItem);
                                            },
                                        }}
                                        tooltip={{
                                            text: addAction.helperText,
                                            props: { placement: "top" },
                                        }}
                                    />)}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Stack>
    );
};
